import * as React from 'react';

import { checkAndUpdateTime } from 'common/components/TimeDisplay/helpers';

export type TimeCellProps = {
  time: string;
  dateTimeFormat?: string;
  className?: string;
};

export enum DateTimeFormat {
  STANDARD = 'MMM Do YYYY HH:mm',
  STANDARD_WITH_SECONDS = 'MMM Do YYYY HH:mm:ss',
  DATE_ONLY = 'MMM Do YYYY',
}

export default function TimeDisplay({ time, dateTimeFormat = DateTimeFormat.STANDARD, className }: TimeCellProps) {
  const currentTime = checkAndUpdateTime(time, dateTimeFormat);

  return (
    <time data-test="time-cell" className={className}>
      {currentTime}
    </time>
  );
}
